import { lulaPostMessageSchema } from './lula-post-message.schema';
import { LulaPostMessage } from './lula-post-message.types';

export const parseLulaPostMessage = (data: unknown): LulaPostMessage => {
  const result = lulaPostMessageSchema.safeParse(data);
  if (result.success) {
    return result.data;
  }
  return { type: 'unknown' };
};
